<template>
  <div class="referral">
    <div class="form-group row">
      <div
        :class="'col-md-6 form-group ' + (validations !== null && validations.hasOwnProperty('invest_type_id') ? 'has-error' : '')"
      >
        <label class="required">{{ $t('fields.investType') }}</label>
        <select
          v-if="investTypes.length > 0"
          v-model="invest.invest_type_id"
          class="form-control"
        >
          <template v-for="(investType, key) in investTypes">
            <option
              :value="investType.id"
              :key="key"
            >
              {{ investType.name }}
            </option>
          </template>
        </select>
        <span
          v-if="validations !== null && validations.hasOwnProperty('invest_type_id')"
          class="label-error"
        >
          {{ validations['invest_type_id'][0] }}
        </span>
      </div>
      <div
        :class="'col-md-6 form-group ' + (validations !== null && validations.hasOwnProperty('name') ? 'has-error' : '')"
      >
        <label class="required">{{ $t('fields.name') }}</label>
        <input
          v-model="invest.name"
          :placeholder="$t('fields.name')"
          class="form-control"
          type="text"
        >
        <span
          v-if="validations !== null && validations.hasOwnProperty('name')"
          class="label-error"
        >
          {{ validations['name'][0] }}
        </span>
      </div>
    </div>

    <div class="form-group row">
      <div
        :class="'col-md-6 form-group ' + (validations !== null && validations.hasOwnProperty('amount') ? 'has-error' : '')"
      >
        <label class="required">{{ $t('fields.amount') }}</label>
        <input
          v-model="invest.amount"
          :placeholder="$t('fields.amount')"
          class="form-control"
          type="text"
        >
        <span
          v-if="validations !== null && validations.hasOwnProperty('amount')"
          class="label-error"
        >
          {{ validations['amount'][0] }}
        </span>
      </div>
      <div
        :class="'col-md-6 form-group ' + (validations !== null && validations.hasOwnProperty('phone') ? 'has-error' : '')"
      >
        <label class="required">{{ $t('fields.phone') }}</label>
        <input
          v-model="invest.phone"
          :placeholder="$t('fields.phone')"
          class="form-control"
          type="text"
        >
        <span
          v-if="validations !== null && validations.hasOwnProperty('phone')"
          class="label-error"
        >
          {{ validations['phone'][0] }}
        </span>
      </div>
    </div>

    <div class="form-group row">
      <div
        :class="'col-md-12 form-group ' + (validations !== null && validations.hasOwnProperty('note') ? 'has-error' : '')"
      >
        <label class="required">{{ $t('fields.note') }}</label>
        <textarea
          v-model="invest.note"
          class="form-control"
          rows="4"
        />
        <span
          v-if="validations !== null && validations.hasOwnProperty('note')"
          class="label-error"
        >
          {{ validations['note'][0] }}
        </span>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-md-12">
        <template v-if="editable">
          <button
            class="btn btn-primary margin-right-5 btn-sm btn-update"
            @click="onClickUpdate"
          >
            {{ $t('buttons.update') }}
          </button>
        </template>
        <button
          class="btn btn-default btn-sm btn-back"
          @click="onClickBack"
        >
          {{ $t('buttons.cancel') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InvestForm',
  props: {
    editable: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      invest: {
        invest_type_id: null,
        name: null,
        amount: null,
        phone: null,
        note: null
      },
      id: null,
      investTypes: [],
      validations: null
    }
  },
  computed: {
    api () {
      let action = 'store'
      if (this.$route.name === 'InvestEdit') {
        action = 'update'
      }
      return process.env.VUE_APP_API + `/api/v1/invests/${action}`
    }
  },
  methods: {
    getInvest () {
      this.$axios.post(process.env.VUE_APP_API + '/api/v1/invests/get-invest', { id: this.id })
        .then((response) => {
          if (response.data.code === 1) {
            this.invest = response.data.data
          }
        })
        .catch((error) => {
          this.onResponseError(error)
        })
    },
    getInvestType () {
      this.$axios.get(process.env.VUE_APP_API + '/api/v1/invests/get-invest-type')
        .then((response) => {
          if (response.data.code === 1) {
            if (response.data.data.length > 0) {
              this.investTypes = response.data.data
            }
          }
        })
    },
    onClickBack () {
      this.$router.push({
        name: 'Invest'
      })
    },
    onClickUpdate () {
      const self = this
      this.$isLoading(true)
      this.$axios.post(this.api, this.invest)
        .then((response) => {
          if (response.data.code === 1) {
            this.$toastr(
              'success',
              self.$t('string.theRecordHasBeenUpdated'),
              self.$t('string.invest')
            )
            this.onClickBack()
          }
          if (response.data.code === 0) {
            this.validations = response.data.message
          }
        })
        .catch((error) => {
          this.onResponseError(error)
        })
        .finally(() => {
          this.$isLoading(false)
        })
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.id = this.$route.params.id
      this.getInvest()
      this.getInvestType()
      if (!this.editable) {
        $('input, textarea').attr('disabled', 'disabled')
        $('select').attr('disabled', true)
      }
    })
  }
}
</script>

<style scoped>

</style>
